import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60aba5a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download-table-part table-wrapper" }
const _hoisted_2 = { class: "searchMain" }
const _hoisted_3 = { class: "d-f" }
const _hoisted_4 = { class: "d-f flex-d-c flex-w-auto m-r-16" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Entity", -1))
const _hoisted_6 = { class: "d-f flex-d-c flex-w-auto m-r-16" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Release Round", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "combinedRoundsTitle blueTitle" }, "Combined Round List", -1))
const _hoisted_9 = { style: {
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
        } }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Release")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Download ")

import { createVNode, reactive, ref } from "vue";
import { Modal, message } from "ant-design-vue";
import { downloadFromStream } from '@/utils/payment/downloadFile'
import { getPreviewDataApi, postReleaseApi, demoCarDeductionDownload } from "@/API/payment";
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  emits: ["set"],
  setup(__props, { expose, emit }: { emit: ({
  (event: 'set'): void
}), expose: any, slots: any, attrs: any }) {



const state = ref({
    visible: false,
    entity: '',
    releaseRound: '',
    combinedRounds: [],
    fileNames: [],
})
const columns = {
    fileNames: [{ title: "File Download", dataIndex: "fileName" }],
    combinedRounds: [{
        title: 'No.',
        customRender: ({ text, record, index, column }: any) => {
            return index + 1
        }
    }, { title: "Payout Round", dataIndex: "payoutRound" }],
}
const modalRowSelection = reactive<any>({
    onChange: (selectedRowKeys: any[]) => {
        modalRowSelection.selectedRowKeys = selectedRowKeys;
    },
    selectedRowKeys: [],
    columnWidth: "20px",
});
const getPreviewData = async (_round: string, _entity: string) => {
    state.value.entity = _entity
    state.value.releaseRound = _round
    modalRowSelection.selectedRowKeys = []
    const res = await getPreviewDataApi(_round, _entity)
    const { combinedRounds = [], fileNames = [] } = res
    state.value.combinedRounds = combinedRounds.map((item: string) => ({ payoutRound: item }))
    state.value.fileNames = fileNames
    setTimeout(() => {
        state.value.visible = true
    }, 0)
};
const modalDownloadClick = async () => {
    if (modalRowSelection.selectedRowKeys.length === 0) {
        message.warning("Please select the data first");
        return;
    }
    const res = await demoCarDeductionDownload(state.value.releaseRound, state.value.entity, modalRowSelection.selectedRowKeys)
    downloadFromStream(res)
};
const close = () => {
    state.value = {
        visible: false,
        entity: '',
        releaseRound: '',
        combinedRounds: [],
        fileNames: [],
    }
};
const release = async () => {
    Modal.confirm({
        title: 'Confirm to Release Demo Car Deduction File!',
        icon: createVNode(ExclamationCircleOutlined),
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk() {
          postRelease().then(() => {
            emit('set')
          })
        }
    });
};
const postRelease = async () => {
    try {
        await postReleaseApi(state.value.releaseRound, state.value.entity)
    } finally {
        close()
    }
}
expose({
    getPreviewData
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: "Download Demo Car Deduction File",
    closable: true,
    visible: state.value.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((state.value.visible) = $event)),
    width: 400
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_a_input, {
                value: state.value.entity,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.value.entity) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_a_input, {
                value: state.value.releaseRound,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.value.releaseRound) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _createVNode(_component_a_table, {
          "row-selection": _unref(modalRowSelection),
          columns: columns.fileNames,
          pagination: false,
          dataSource: state.value.fileNames,
          rowKey: "fileId"
        }, null, 8, ["row-selection", "columns", "dataSource"]),
        _hoisted_8,
        _createVNode(_component_a_table, {
          columns: columns.combinedRounds,
          pagination: false,
          dataSource: state.value.combinedRounds,
          rowKey: "payoutRound"
        }, null, 8, ["columns", "dataSource"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_button, {
          type: "primary",
          style: {"margin-right":"8px"},
          onClick: release
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          style: {"margin-right":"8px"},
          onClick: close
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: modalDownloadClick,
          disabled: _unref(modalRowSelection).selectedRowKeys.length == 0
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})